const tbankHandler = (form) => {
    const {description, amount, email, phone, receipt, order} = form;

    if (receipt) {
        if (!email.value && !phone.value)
            return alert("Поле E-mail или Phone не должно быть пустым");

        form.receipt.value = JSON.stringify({
            "EmailCompany": "mail@demkinalebedeva.com",
            "Taxation": "usn_income",
            "FfdVersion": "1.05",
            "Items": [
                {
                    "Name": description.value || "Оплата",
                    "Price": Math.round(amount.value * 100),
                    "Quantity": 1.00,
                    "Amount": Math.round(amount.value * 100),
                    "PaymentMethod": "full_prepayment",
                    "PaymentObject": "commodity",
                    "Tax": "none",
                    "MeasurementUnit": "pc"
                }
            ]
        });
    }
    pay(form);
}

const formV2Handler = () => {
    const forms = document.querySelectorAll('.form');

    if (!forms) return;

    forms.forEach((form) => {
        if (form.classList.contains('--disable-default-handler')) return;
        const errorLabels = form.querySelectorAll('.form__error');
        const clearErrorLabels = () => errorLabels.forEach((el) => el.innerText = '');
        const dialogMessages = {
            sending: 'Отправка...',
            success: 'Спасибо! Ваша заявка отправлена.',
            error: 'Ошибка! Отправка не удалась.',
        };
        const formSubmitButton = form.querySelector('.form__submit');
        const formDialog = form.querySelector('.form__notification');
        const formDialogText = formDialog.querySelector('.form__notification-text');
        const formDialogCloseButton = formDialog.querySelector('.form__close-notification');

        formSubmitButton.addEventListener('click', (e) => {
            e.preventDefault();
            clearErrorLabels();

            formDialog.classList.add('--is-visible');
            formDialogText.innerText = dialogMessages.sending;

            const formData = new FormData(form);

            fetch('index.php?route=form/common', {
                method: 'POST',
                body: formData,
            })
                .then((response) => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then((data) => {
                    console.log(data);
                    if (data.errors.length === 0) {
                        if (!form.classList.contains('payform-tbank')) {
                            formDialog.classList.add('--is-visible');
                            formDialogText.innerText = dialogMessages.success;
                            setTimeout(() => formDialog.classList.remove('--is-visible'), 7000);
                        } else {
                            const tbankOrderId = form.querySelector('input.payform-tbank-row[name="order"]');
                            if (data['lead-id'] && tbankOrderId) {
                                tbankOrderId.value = data['lead-id'];
                                console.log(`LEAD-ID: ${data['lead-id']}`);
                            }
                            tbankHandler(form);
                        }
                    } else {
                        setTimeout(() => formDialog.classList.remove('--is-visible'), 1000);
                        // Перебираем ошибки
                        Object.keys(data.errors).forEach((errorKey) => {
                            // Находим соответствующий элемент с data-name, равным errorKey
                            const errorLabel = Array.from(errorLabels).find(
                                (label) => label.dataset.name === errorKey
                            );

                            // Если элемент найден, добавляем текст ошибки
                            if (errorLabel) {
                                errorLabel.textContent = data.errors[errorKey];
                                errorLabel.classList.add('visible'); // Класс для отображения ошибки (опционально)
                            } else {
                                console.warn(`Не найден элемент для ошибки: ${errorKey}`);
                            }
                        });
                    }
                })
                .catch((err) => {
                    formDialog.classList.add('--is-visible');
                    formDialogText.innerText = dialogMessages.error;
                    setTimeout(() => formDialog.classList.remove('--is-visible'), 7000);
                    console.log(err);
                });
        });

        formDialogCloseButton.addEventListener('click', (e) => {
            e.preventDefault();
            formDialog.classList.remove('--is-visible');
        });
    });
}

export default formV2Handler;
